// https://play.tailwindcss.com/Ci50wy5ndt?size=1494x1452&file=config

module.exports = (theme) => ({
  // Styles for regular link without dropdown
  ".no-dropdown-summary": {
    display: "inline-block  !important",
    width: "350px",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  ".no-dropdown summary a": {
    color: "black",
    padding: "0px 0 0px 35px",
    fontWeight: theme("fontWeight.regular"),
    fontSize: theme("fontSize.xl"),
  },

  ".no-dropdown summary a:before": {
    marginTop: "2px",
  },

  // Dropdown
  ".service-block": {
    maxWidth: theme("screens.xl"),
    marginLeft: "auto",
    marginRight: "auto",
  },

  ".service-block-container": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "auto",
    marginLeft: "auto",
    paddingTop: theme("spacing.xl"),
    paddingBottom: theme("spacing.xl"),
    paddingLeft: theme("spacing.lg"),
    paddingRight: theme("spacing.lg"),
  },

  ".service-block-media": {
    paddingLeft: "0",
    paddingRight: "0",
    width: "300px",
  },

  ".service-block-round-image": {
    display: "flex",
    justifyContent: "center",
    marginBottom: "30px",
  },

  ".service-block-round-image img": {
    borderRadius: "50%",
    minHeight: "250px",
    minWidth: "250px",
    objectFit: "cover",
    width: "150px",
  },

  ".select": {
    position: "relative",
    display: "inline-block",
    userSelect: "none",
    fontFamily: "'Vattenfall Hall', Helvetica, sans-serif",
    fontSize: "1.25rem",
    fontWeight: "400",
    minWidth: "350px",
    maxWidth: "300px",
  },

  ".select details summary": {
    padding: "10px 1.5rem",
  },

  ".select details > *": {
    borderRadius: "0.375rem",
    borderWidth: "3px",
    borderColor: "rgb(255 255 255)",
    backgroundColor: "rgb(255 255 255)",
    outlineStyle: "solid !important",
    outlineWidth: "1px !important",
    outlineOffset: "0px",
    outlineColor: "#CCCCCC !important",
  },

  ".select:hover details > *,.select:focus-within details > *": {
    outlineColor: "#999999 !important",
  },

  ".select details[open] > *": {
    borderColor: "#2071B530",
  },

  ".select details[open] summary": {
    clipPath: "inset(-100px -1px 3px -1px)",
    WebkitClipPath: "inset(-100px -1px 3px -1px)",
  },

  ".select details[open] ul": {
    clipPath: "inset(1px -1px -3px -1px)",
    WebkitClipPath: "inset(1px -1px -3px -1px)",
    transform: "translateY(-5px)",
    overflowY: "scroll",
    maxHeight: "300px",
  },

  ".select details ul": {
    position: "absolute",
    zIndex: "50",
    width: "100%",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderTopWidth: "0px",
  },

  ".select details summary::after": {
    aspectRatio: "1 / 1",
    height: "20px",
    width: "auto",
    padding: "0rem",
  },

  ".service-dropdown-link": {
    display: "block",
    color: "black",
    fontSize: "20px",
    minWidth: "260px",
    padding: "10px 1.5rem",
  },

  ".service-dropdown-link:focus-within ": {
    border: "1px solid theme('colors.tertiary.darkblue')",
  },

  ".service-dropdown-link:hover": {
    color: "white",
  },

  ".dropdown-item:hover": {
    backgroundColor: "#1964a3",
    color: "white",
    cursor: "pointer",
  },
});
